import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import withAuth from 'enhancers/withAuth';

class Sidebar extends Component {
  state = {};
  role = '';
  constructor(props) {
    super(props);
    if (props.user && props.user.profile_role) {
      this.role = props.user.profile_role;
    }
  }

  render() {
    return (
      <ul className="sidebar navbar-nav">
        <li className="nav-item">
          <Link className="nav-link" to="/dashboard">
            <i className="fas fa-fw fa-home" />
            <span> Dashboard</span>
          </Link>
        </li>

        {/* <li className="nav-item">
          <Link className="nav-link" to="/activities">
            <i className="fas fa-fw fa-user-clock" />
            <span> Activities</span>
          </Link>
        </li> */}

{/*
<li className="nav-item">
          <Link className="nav-link" to="/attendance">
            <i className="fas fa-fw fa-calendar-alt" />
            <span> Attendance</span>
          </Link>
</li>*/}

       {(this.role === 'admin') &&
        <li className="nav-item">
          <Link className="nav-link" to="/user_admins">
            <i className="fas fa-fw fa-users" />
            <span> Admins</span>
          </Link>
        </li>}
        {(this.role === 'admin' || this.role === 'registrar') &&
        <li className="nav-item">
          <Link className="nav-link" to="/user_members">
            <i className="fas fa-fw fa-users" />
            <span> Members</span>
          </Link>
        </li>}
        {(this.role === 'admin') &&
        <li className="nav-item">
          <Link className="nav-link" to="/user_registrars">
            <i className="fas fa-fw fa-users" />
            <span> Registrars</span>
          </Link>
        </li>}
        {(this.role === 'admin') &&
        <li className="nav-item">
          <Link className="nav-link" to="/user_trainers">
            <i className="fas fa-fw fa-users" />
            <span> Trainers</span>
          </Link>
        </li>}

        {/* <li className="nav-item">
          <Link className="nav-link" to="/invoices">
            <i className="fas fa-fw fa-file-invoice-dollar" />
            <span> Invoices</span>
          </Link>
        </li> */}

        {(this.role === 'admin' || this.role === 'registrar') &&
        <li className="nav-item">
          <Link className="nav-link" to="/subscriptions">
            <i className="fas fa-fw fa-id-card" />
            <span> Subscriptions</span>
          </Link>
        </li>}

        {(this.role === 'admin') &&
        <li className="nav-item">
          <Link className="nav-link" to="/packages">
            <i className="fas fa-fw fa-box" />
            <span> Packages</span>
          </Link>
        </li>}
        
        {/*
        <li className="nav-item">
          <Link className="nav-link" to="/billing-cycles">
            <i className="fas fa-fw fa-clock" />
            <span> Billing Cycles</span>
          </Link>
        </li>*/}
        {(this.role === 'admin') &&
        <li className="nav-item">
          <Link className="nav-link" to="/services">
            <i className="fas fa-fw fa-server" />
            <span> Services</span>
          </Link>
        </li>}

        {(this.role === 'admin') &&
        <li className="nav-item">
          <Link className="nav-link" to="/events">
            <i className="fas fa-fw fa-server" />
            <span> Events</span>
          </Link>
        </li>}
      </ul>
    );
  }
}

export default withAuth(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Layouts/Sidebar.js